import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const FeaturePlaceholder = ({ 
    title, 
    icon: Icon, 
    themeColor,
    pageTitle // Optional, defaults to "Title - Coming Soon"
}) => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <Helmet>
                <title>{pageTitle || `${title} - Coming Soon`}</title>
            </Helmet>
            <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                bgcolor: themeColor,
                px: 3
            }}>
                <Icon sx={{ fontSize: 200, color: 'white', mb: 4 }} />
                <Typography 
                    variant="h1" 
                    fontWeight="900"
                    sx={{ 
                        color: 'white',
                        fontSize: { xs: '3rem', md: '4rem' },
                        textAlign: 'center',
                        mb: 2,
                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                >
                    {title}
                </Typography>
                <Typography 
                    variant="h3"
                    sx={{ 
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontSize: { xs: '1.5rem', md: '2rem' },
                        textAlign: 'center',
                        mb: 4
                    }}
                >
                    Coming Soon!
                </Typography>
                <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate('/family-central')}
                    sx={{
                        bgcolor: 'white',
                        color: themeColor,
                        fontWeight: 'bold',
                        fontSize: '1.2rem',
                        px: 4,
                        py: 2,
                        borderRadius: 3,
                        boxShadow: 2,
                        '&:hover': {
                            bgcolor: 'rgba(255, 255, 255, 0.9)',
                            boxShadow: 4
                        }
                    }}
                >
                    Back to Family Central
                </Button>
            </Box>
        </React.Fragment>
    );
};

export default FeaturePlaceholder;
